/* eslint-disable no-unused-vars */
import { $http, http } from '@/utils/http'
import host from '@/utils/host'
import queryString from 'query-string'
import { toLogin } from "../utils/utils";
import { report } from '@/utils/reportError'
import { hasNeedLoginKeyWords } from '@/utils/handleError'
import Cookies from 'js-cookie'
import { _ } from 'core-js';
import moment  from 'moment';

export default {
    namespaced: true,
    state: {
        noticeList: [],
        remind: {},
        top5Data: [],
        activities: [],
        portalMenus: [],
        tripartiteState: 0, // 0未查询到进件状态 1部分进件成功 2全部进件成功
        honourTimeInfo: {}, // 荣耀时刻信息
        storeStarInfo: '', //店铺星级信息
        super_store_flag: 1, //王牌好店标识
        dsrRate: [
          {name:'商品评价',score:'--'},
          {name:'商家服务',score:'--'},
          {name:'物流配送',score:'--'}
        ], //dsr动态评分
        winInfo: {}, // win版工作台版本信息，
        overCollectDetail: [],
        overCollectSummary: {},
        expiresTime: '', // 过期时间
        expiresStatus: false // 过期状态
    },
    mutations: {
        setRemind(state, data) {
            state.remind = {...state.remind, ...data }
        },
        setMutation(state, { data, namespace }) {
            state[namespace] = data
        },
        setOverSummary(state, data) {
            state.overCollectSummary = {...state.overCollectSummary, ...data }
        },
        setExpiresTime(state, data) {
            state.expiresTime = data
        },
        setExpiresStatus(state, data) {
            console.log(data)
            state.expiresStatus = data
        }
    },
    actions: {
        // 成长力, 由于大数据限制，现在查数据只有传今天之前的2天才能保证肯定有数据
        // 域名不通（改成移动端域名 通用）2020-7-23
        async queryScoreDetail({ commit }, { sellerId, date }) {
            const url = `${host.score}/bscore-web/spt/queryScoreDetail.do?sellerId=${sellerId}&date=${date}`
            const res = await http.get(url)
            if (res) {
                return res.data || {}
            } else {
                report({
                    url,
                    res,
                    msg: res.msg || '工作台获取成长力信息接口异常'
                })
                return {}
            }
        },
        // 待办提醒-其他
        async getShopRemind({ commit }) {
            const url = `${host.popManage}/partners-popmanage-web/main/getShopRemind.do`
            const res = await $http.get(url)
            if (res && res.code * 1 === 1) {
                commit('setRemind', res.data || {})
            } else if (hasNeedLoginKeyWords(res)) {
                !res.report && report({
                    url,
                    res,
                    msg: '去登陆'
                })
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台获取待办提醒信息接口异常'
                })
                return {}
            }
        },
        // 待办提醒-违规提醒
        // 功能替换废弃
        // async getMarkRemind({ commit }) {
        //     const url = `${host.popManage}/partners-popmanage-web/main/getMarkRemind.do`
        //     const res = await $http.get(url)
        //     if (res && res.code * 1 === 1) {
        //         commit('setRemind', res.data || {})
        //     } else {
        //         !res.report && report({
        //             url,
        //             res,
        //             msg: res.msg || '工作台获取待办提醒信息接口异常'
        //         })
        //         return {}
        //     }
        // },
        async getDealExRemind({ commit }) {
            const partner_id = Cookies.get('buzzId')
            const url = `${host.ksds}/oda/qrySumExt.do?partner_id=${partner_id}`
            const res = await $http.get(url)
            if (res && res.resultCode * 1 === 0) {
                const remindObj = {
                    dealExNotShipp: 0,
                    dealExWillNotVote: 0,
                    dealExNotVote: 0
                }
                res.result && res.result.forEach((item) => {
                    switch (String(item.deal_ex_status_code)) {
                        case '1': // 超期未发货
                            remindObj.dealExNotShipp = Number(item.nums)
                            break
                        case '2': // 即将超期未妥投
                            remindObj.dealExWillNotVote = Number(item.nums)
                            break
                        case '3': // 超期未妥投
                            remindObj.dealExNotVote = Number(item.nums)
                            break
                        default:
                            break
                    }
                })
                commit('setRemind', remindObj)
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台获取待办提醒信息接口异常'
                })
                return {}
            }
        },
        async getPrewardPunisRemind({ commit }) {
            const url = `${host.hbprewardpunish}/hbp-rewardpunish-web/business/ruledan/queryRuleOverview.do`
            const res = await $http.get(url)
            if (res && res.code * 1 === 0) {
                commit('setRemind', res.data || {})
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台获取违规概览接口异常'
                })
                return {}
            }
        },
        // 商品概况，销售Top5和滞销Top5
        // async getTop5Data({commit}, {type}) {// type:1 销售Top5，2:滞销Top5
        //   const res = await $http.get(`${host.popManage}/partners-popmanage-web/main/getTop5Data.do?type=${type}`)
        //   if (res instanceof Array && res.length > 0) {
        //     commit('setMutation', {
        //       namespace: 'top5Data',
        //       data: res
        //     })
        //   }
        //   return res || []
        // },
        // 交易概况 今日 本周 本月数据
        // async queryTradeData({commit}, {cycleType}) { // cycleType:1:今日，2:本周，3:本月
        //   const res = await $http.get(`${host.popManage}/partners-popmanage-web/main/getHistoricalData.do?cycleType=${cycleType}`)
        //   console.log(res)
        //   return res || []
        // },
        // async getOnTimeData() { // 交易概况模块实时数据
        //   const res = await $http.get(`${host.popManage}/partners-popmanage-web/main/getOnTimeData.do`)
        //   console.log(res)
        //   return res || {}
        // },
        async getNoticeList({ commit }) { //公告
            const url = `${host.popManage}/partners-popmanage-web/mainNew/getNoticeList.do`
            const res = await $http.get(url)
            if (res && res.code * 1 === 1) {
                return res.data.noticeList || []
            } else if (hasNeedLoginKeyWords(res)) {
                !res.report && report({
                    url,
                    res,
                    msg: '去登陆'
                })
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台获取公告信息接口异常'
                })
                return []
            }
        },
        async sendPhoneMsg({ commit }, params) {
            const url = `${host.portal}/portal-api/user/sendPhoneMsgNeedLogin.do`
            const res = await $http.post(url, queryString.stringify(params), {
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            })
            return res
        },
        async getAppKey({ commit }, params) {
            const res = await $http.get(`${host.portal}/portal-api/user/getAppkey.do?${queryString.stringify(params)}`)
            return res
        },
        async updateAppkey({ commit }, params) {
            const res = await $http.get(`${host.portal}/portal-api/user/updateAppkey.do?${queryString.stringify(params)}`)
            return res
        },
        async getKeyExpiresTime({ commit }, params) {
            const res = await $http.get(`${host.portal}/portal-api/user/getAppkeyExpiresTime.do`)
            commit('setExpiresTime', res.data.expiresTime ? (moment().unix() * 1000 >  res.data.expiresTime ? 'AppKey已过期，请及时更新' :`AppKey有效期至:${moment(res.data.expiresTime).format('YYYY.MM.DD')}` ): '' )
            commit('setExpiresStatus',  (moment().unix() * 1000 >  res.data.expiresTime ? true : false ))
            return res
        },
        /**
         * 获取活动
         * @param commit
         * @param params
         * @returns {Promise<void>}
         */
        async getActivities({ commit }, params) {
            const url = `${host.collection}/pop/product-collection/all-activities`
            const json = await $http.get(`${url}?${queryString.stringify(params)}`)
            if (json && json.data && Array.isArray(json.data.list)) {
                return json.data.list
            } else {
                return []
            }

            // } else if (code * 1 === 1024) {
            //   toLogin()
            // } else {
            //   report({
            //     url,
            //     params,
            //     res,
            //     msg: res.msg || '工作台获取营销活动信息接口异常'
            //   })
            //   return []
            // }
        },
        async getTradeInfo({ commit }, param) {
            const url = `${host.zhs}/zhs-api/trade/getTradeInfo.do`
            const res = await $http.get(`${url}?param=${JSON.stringify(param)}`)
            if (res && res.code * 1 === 1) {
                return res.data || {}
            } else if (res.code * 1 === 2) {
                toLogin()
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台POP获取数据参谋交易概况总揽异常'
                })
            }
            return res.data
        },
        async getTradeDetail({ commit }, param) {
            const url = `${host.zhs}/zhs-api/trade/getTradeDetail.do`
            const res = await $http.get(`${url}?param=${JSON.stringify(param)}`)
            if (res && res.code * 1 === 1) {
                return res.data || {}
            } else if (res.code * 1 === 2) {
                toLogin()
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台POP获取数据参谋交易概况每日接口异常'
                })
            }
            return res.data
        },
        // {"isTop10":1:Top,"commodityType":"2","cycleType":1,"occurtime":20200326}
        // {"isTop10":1:Last,"commodityType":"2","cycleType":1,"occurtime":20200326}
        async getCountTen({ commit }, param) {
            const url = `${host.zhs}/zhs-api/commodity/getCountTen.do`
            const res = await $http.get(`${url}?param=${JSON.stringify(param)}`)
            if (res && res.code * 1 === 1) {
                commit('setMutation', {
                    namespace: 'top5Data',
                    data: (res.data || []).slice(0, 5)
                })
            } else if (res.code * 1 === 2) {
                toLogin()
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台POP获取数据参谋商品概况接口异常'
                })
            }
            return res.data
        },
        async getTripartiteState({ commit }, params) {
            const url = `${host.ms}/ms-web/account/queryAccount.do`
            const res = await $http.post(url, params, {})
            if (res && res.code * 1 === 1) {
                commit('setMutation', {
                    namespace: 'tripartiteState',
                    data: res.data ? +res.data.finishState : 0
                })
            } else if (res.code * 1 === 2) {
                toLogin()
            } else {
                !res.report && report({
                    url,
                    res,
                    msg: res.msg || '工作台POP获取三方进件状态接口异常'
                })
            }
            return res.data
        },
        // 获取荣耀时刻信息
        async getHonourTimeState({ commit }) {
            const url = `${host.hbpsupplier}/hbp-supplier-web/hbppc/shop/honour/businessHonourInfo.do`
            const res = await $http.get(`${url}`)
            if (res && res.code == 0) {
                commit('setMutation', {
                    namespace: 'honourTimeInfo',
                    data: res.data ? res.data : {}
                })
            }
        },
        // 通知服务端荣耀时刻弹窗已展示
        async setHonourFlag({ commit }, honourId) {
            const url = `${host.hbpsupplier}/hbp-supplier-web/hbppc/shop/honour/honourShowFlag.do`
            await $http.get(`${url}?${queryString.stringify({honourId})}`)
        },
        // 通知服务端公告弹窗已展示
        async setAnnouncementFlag({ commit }, { afficheId, operationType }) {
            const url = `${host.hbpnotice}/hbp-notice/hbppc/outnet/affiche/afficheCallback.do`
            await $http.get(`${url}?${queryString.stringify({afficheId, operationType, source: 1})}`)
        },
        // 后端重新包了一层 加了登录态
        async queryScoreDetailInfo({ commit }, { date }) {
            const url = `${host.score}/bscore-web/hbppc/spt/queryScoreDetailInfo.do?&date=${date}`
            const res = await $http.get(url)
            if (res) {
                return res.data || {}
            } else {
                report({
                    url,
                    res,
                    msg: res.msg || '工作台获取成长力信息接口异常'
                })
                return {}
            }
        },
        // 获取店铺星级信息
        async queryStarLevel ({commit}) {
          const url = `${host.score}/bscore-web/star/queryStarLevel.do?business_id=${Cookies.get('buzzId')}`
          const res = await $http.get(url)
          if (res && res.resultCode == 0) {
            commit('setMutation', {
              namespace: 'storeStarInfo',
              data: res.result ? res.result : ''
            })
          }
        },
        // 获取王牌好店标识
        async querySuperStore({commit}) {
					let business_id = Cookies.get('buzzId')
          const url = `${host.score}/bscore-web/star/querySuperStore.do?business_id=${ business_id ? business_id : ''}`
          const res = await $http.get(url)
          if (res && res.resultCode == 0) {
            commit('setMutation', {
              namespace: 'super_store_flag',
              data: (res.result && res.result.super_store_flag) ? res.result.super_store_flag : 0
            })
            let dsrRate = this.state.popHome.dsrRate
            res.result && res.result.dsr_sku_cmt_score && (dsrRate[0].score = res.result.dsr_sku_cmt_score)
            res.result && res.result.dsr_sku_cmt_hl && (dsrRate[0].level = res.result.dsr_sku_cmt_hl)

            res.result && res.result.dsr_serv_attitu_cmt_score && (dsrRate[1].score = res.result.dsr_serv_attitu_cmt_score)
            res.result && res.result.dsr_serv_attitu_cmt_hl && (dsrRate[1].level = res.result.dsr_serv_attitu_cmt_hl)

            res.result && res.result.dsr_logis_time_cmt_score && (dsrRate[2].score = res.result.dsr_logis_time_cmt_score)
            res.result && res.result.dsr_logis_time_cmt_hl && (dsrRate[2].level = res.result.dsr_logis_time_cmt_hl)

            commit('setMutation', {
              namespace: 'dsrRate',
              data: dsrRate
            })
          }
        },

        // 查询课程列表 (学习中心、常见问题、工具教程)
        async queryCourseList({commit}, params) {
          const url = `${host.hbpcollege}/hbp-college/course/manager/queryCourseList.do`
          const res = await $http.post(url, queryString.stringify(params), {
            headers: {
                'content-Type': 'application/x-www-form-urlencoded'
            }
          })
          return res
        },
        // 获取报名活动
        async queryProductionCollection({commit}, params) {
          const url = `${host.collection}/pop/product-collection/activities`
          const res = await $http.get(`${url}?${queryString.stringify(params)}`)
          return res
        },
        // 数据参谋 - 实时数据
        async queryRealTimeDate({commit}) {
          const url = `${host.zhs}/zhs-api/actual/queryRealTimeForEachHour.do`
          const res = await $http.get(url)
          return res
        },
        // 数据参谋 - 实时成交榜
        async queryTopData({commit}) {
          const url = `${host.zhs}/zhs-api/actual/queryTopData.do`
          const res = await $http.get(url)
          return res
        },
        // 数据参谋 - 获取Top10 商品概况 [按日查看 - 昨日]
        async getCommodityInfo({commit}, params) {
          const url = `${host.zhs}/zhs-api/commodity/getCommodityInfo.do`
          const res = await $http.get(`${url}?${queryString.stringify({param:JSON.stringify(params)})}`)
          return res
        },
        // 获取win版工作台版本信息
        async queryWin ({commit}) {
            const url = `${host.cms}/publish/976/winversion.json`
            const res = await http.get(url)
            commit('setMutation', {
                namespace: 'winInfo',
                data: res
            })
        },

        // 获取超期未揽件汇总
        async getOverCollectSummary ({commit},params) {
            const url = `${host.bh}/platform/over_collect_summary`
            const res = await $http.get(`${url}?${queryString.stringify({params,type: 2,start_date: moment().format('YYYY-MM-DD')})}`)
            commit('setOverSummary', {
                overDealCnt: res.data
            })
        },
        // 获取即将超期未揽件汇总
        async getReadyOverCollectSummary ({commit},params) {
            const url = `${host.bh}/platform/over_collect_summary`
            const res = await $http.get(`${url}?${queryString.stringify({params,type: 1,start_date: moment().format('YYYY-MM-DD')})}`)
            commit('setOverSummary', {
                readyOverDealCnt: res.data
            })
        },
        
        // 获取超期未揽件明细
        async getOverCollectDetail ({commit},params) {
            const url = `${host.bh}/platform/over_collect_detail`
            const res = await $http.get(`${url}?${queryString.stringify(params)}`)
            commit('setMutation', {
                namespace: 'overCollectDetail',
                data: res
            })
        }
    }
}
